import VueI18n from 'vue-i18n';
import enUsTranslations from './lang/en-us.json';

const messages = {
    en: enUsTranslations,
};

export default function translate(locale, overrides) {
    const translations = JSON.parse(JSON.stringify(messages));

    if (overrides) {
        Object.keys(translations).forEach((lang) => {
            if (overrides[lang]) {
                Object.assign(translations[lang], overrides[lang]);
            }
        });

        Object.keys(overrides).forEach((lang) => {
            if (overrides[lang]) {
                if (translations[lang] == null) {
                    translations[lang] = {};
                }
                Object.assign(translations[lang], overrides[lang]);
            }
        });
    }

    return new VueI18n({
        locale,
        fallbackLocale: 'en',
        messages: translations,
        silentFallbackWarn: true,
    });
}
